




































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { LabelModule } from '@/store/modules/label';
import LabelList from './labelList.vue';
import {
  requestAddLabels,
  requestDeleteLabels,
} from '@/components/label/labelOperation';

type ILabelInfo = ILabel.IResponse.ILabelInfo;
type IUpdateLabelList = ILabel.IRequest.IUpdateLabelList;

@Component({
  components: {
    LabelList,
  },
})
export default class LabelOperation extends Vue {
  private editLabelStatus = '';
  private selectedList: string[] = [];
  private removedList: string[] = [];
  private currentLabels: ILabelInfo[] = [];
  private addLabels: ILabelInfo[] = [];
  private visible: boolean = false;
  @Prop({ default: () => [] }) private labels!: ILabelInfo[];
  @Prop({ default: '' }) private url!: string;
  // 对外暴露修改submitAddLabels方法
  public changeTheRequestFunctionForAddLabels(
    fun: (labelIds: string[]) => Promise<string>,
  ) {
    this.submitAddLabels = fun;
  }
  // 对外暴露修改submitDelLabels方法
  public changeTheRequestFunctionForDeleteLabels(
    fun: (labelIds: string[]) => Promise<string>,
  ) {
    this.submitDelLabels = fun;
  }
  get newLabels() {
    const labels = [...LabelModule.labels];
    const result = labels.filter((label) => {
      return !this.labelIds.includes(label.id);
    });
    return result;
  }
  get labelIds() {
    return this.currentLabels.map((label) => label.id);
  }
  @Watch('labels', { immediate: true })
  private watchLabels(newValue: ILabelInfo[]) {
    this.currentLabels = [...newValue];
  }
  private created() {
    LabelModule.GetLabels();
  }
  private submitAddLabels(labelIds: string[]): Promise<string> {
    return new Promise((reslove, reject) => {
      if (!this.url.trim()) {
        reject('no url');
        return;
      }
      requestAddLabels(this.url, labelIds)
        .then((res) => {
          reslove(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
  private submitDelLabels(labelIds: string[]): Promise<string> {
    return new Promise((reslove, reject) => {
      if (!this.url.trim()) {
        reject('no url');
        return;
      }
      requestDeleteLabels(this.url, labelIds)
        .then((res) => {
          reslove(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
  private saveEdit() {
    if (this.selectedList.length === 0 && this.removedList.length === 0) {
      this.editLabelStatus = '';
      return;
    }
    const labels = this.generateLabels({
      addIds: this.selectedList,
      deleteIds: this.removedList,
    });
    if (this.editLabelStatus === 'ADD') {
      this.submitAddLabels(this.selectedList)
        .then((res) => {
          this.$message.success('Success');
          this.editLabelStatus = '';
          this.$emit('change', labels);
        })
        .catch((err) => {
          this.$message.warning(err);
        });
      return;
    }
    if (this.editLabelStatus === 'DEL') {
      this.submitDelLabels(this.removedList)
        .then((res) => {
          this.$message.success('Success');
          this.editLabelStatus = '';
          this.$emit('change', labels);
        })
        .catch((err) => {
          this.$message.warning(err);
        });
      return;
    }
  }
  private generateLabels(labelIds: IUpdateLabelList): ILabelInfo[] {
    const newLabels: ILabelInfo[] = this.labels.filter((label) => {
      return labelIds.deleteIds.indexOf(label.id) < 0;
    });
    labelIds.addIds.forEach((labelId) => {
      const result = this.addLabels.find((label) => label.id === labelId);
      newLabels.push(result!);
    });
    return newLabels;
  }
  private cancelEdit() {
    this.editLabelStatus = '';
  }
  private handleAdd() {
    this.resetEdit();
    this.editLabelStatus = 'ADD';
  }
  private handleDel() {
    this.resetEdit();
    this.editLabelStatus = 'DEL';
  }
  private resetEdit() {
    this.removedList = [];
    this.selectedList = [];
    this.addLabels = [];
    this.currentLabels = [...this.labels];
  }
  private toggleSelect(id: string) {
    const index = this.selectedList.indexOf(id);
    if (index >= 0) {
      this.selectedList.splice(index, 1);
    } else {
      this.selectedList.push(id);
    }
  }
  private confirmLabels() {
    const newAddLabels: ILabelInfo[] = [];
    this.selectedList.forEach((labelId) => {
      const findedlabel = this.newLabels.find((label) => label.id === labelId);
      newAddLabels.push(findedlabel!);
    });
    this.addLabels = newAddLabels;
    this.visible = false;
  }
  private removeAddedLabel(labelId: string) {
    const newAddLabels = this.addLabels.filter((label) => label.id !== labelId);
    const newSelectedList = this.selectedList.filter(
      (selectedLabelId) => selectedLabelId !== labelId,
    );
    this.selectedList = newSelectedList;
    this.addLabels = newAddLabels;
  }
  private removeCurrentLabel(labelId: string) {
    const newCurrentLabels = this.currentLabels.filter(
      (label) => label.id !== labelId,
    );
    this.currentLabels = newCurrentLabels;
    this.removedList.push(labelId);
  }
}
